import QueryString from "query-string";
import {
  all,
  call,
  put,
  select,
  takeEvery,
  takeLatest,
} from "redux-saga/effects";
import api from "../../utils/api";
import { errorAlert, successAlert } from "../Alerts/actions";
import {
  addLeaveFailure,
  addLeaveSuccess,
  aprroveLeaveFailure,
  aprroveLeaveSuccess,
  deleteLeaveFailure,
  deleteLeaveSuccess,
  editLeaveFailure,
  editLeaveSuccess,
  fetchHistoryFailure,
  fetchHistorySuccess,
  fetchLeaveFailure,
  fetchLeaveSuccess,
  fetchRequestsFailure,
  fetchRequestsSuccess,
  fetchDirectorApprovalCountSuccess,
  fetchDirectorApprovalCountFailure,
  getViewDataFailure,
  getViewDataSuccess,
  getYearsFailure,
  getYearsSuccess,
  setAllowanceFailure,
  setAllowanceSuccess,
  fetchMonthSuccess,
  fetchMonthFailure,
  getHistorySuccess,
  getHistoryFailure,
  getHomeLeavesFailure,
  getHomeLeavesSuccess,
  deleteFileSuccess,
  deleteFileFailure,
  fetchReportListSuccess,
  fetchReportListFailure,
  getAccrualLeaveSuccess,
  getAccrualLeaveFailure,
  getAccrualPeriodSuccess,
  getAccrualPeriodFailure,
  exportAccrualSuccess,
  exportAccrualFailure,
  exportLeaveSuccess,
  exportLeaveFailure,
  getAvgHoursSuccess,
  getAvgHoursFailure,
  previewAnnualLeaveSuccess,
  previewAnnualLeaveFailure,
} from "./actions";
import {
  ADD_LEAVE,
  PREVIEW_ANNUAL_LEAVE,
  EDIT_LEAVE,
  DELETE_LEAVE,
  FETCH_LEAVE,
  GET_VIEW_DATA,
  SET_ALLOWANCE,
  GET_YEARS,
  FETCH_HISTORY,
  FETCH_REQUESTS,
  FETCH_DIRECTOR_APPROVAL_COUNT,
  APRROVE_LEAVE,
  FETCH_MONTH,
  GET_HISTORY,
  GET_HOME_LEAVES,
  DELETE_FILE,
  FETCH_REPORT_LIST,
  GET_ACCRUAL_LEAVE,
  GET_ACCRUAL_PERIOD,
  EXPORT_ACCRUAL,
  EXPORT_LEAVE,
  GET_AVG_HOURS,
} from "./constants";

export function* previewAnnualLeaveSaga({ payload, onSuccess, onFailure }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const { data } = yield call(
      api(token).post,
      `/api/employee-leave/annual-preview`,
      payload,
    );
    yield put(previewAnnualLeaveSuccess(data));
    typeof onSuccess === "function" && onSuccess(data);
    return data;
  } catch (e) {
    yield put(previewAnnualLeaveFailure());
    typeof onFailure === "function" && onFailure(e);
    throw e;
  }
}

export function* fetchLeaveSaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  let query = payload?.filters ? QueryString.stringify(payload?.filters) : "";
  try {
    const { data } = yield call(
      api(token).get,
      `/api/work-location-employee/${payload.employee_id}/?${query}`,
    );
    yield put(fetchLeaveSuccess(data));
  } catch (e) {
    yield put(fetchLeaveFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
    else if (e.message !== undefined)
      yield put(errorAlert("Error while fetching leave!"));
  }
}

export function* addLeaveSaga({ payload, onAddSuccess }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const { data } = yield call(
      api(token).post,
      `/api/employee-leave/add`,
      payload,
    );
    if (data) {
      yield put(successAlert("Leave added successfully!"));
      yield put(addLeaveSuccess());
      typeof onAddSuccess === "function" && onAddSuccess(data);
    }
  } catch (e) {
    yield put(addLeaveFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
  }
}

export function* editLeaveSaga({ payload, onEditSuccess }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const data = yield call(
      api(token).post,
      `/api/employee-leave/edit/${payload.id}`,
      payload.data,
    );
    if (data) {
      yield put(successAlert("Leave updated successfully!"));
      yield put(editLeaveSuccess());
      typeof onEditSuccess === "function" && onEditSuccess();
    }
  } catch (e) {
    yield put(editLeaveFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
  }
}

export function* getViewDataSaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const { data } = yield call(
      api(token).get,
      `/api/employee-leave/${payload}`,
    );
    yield put(getViewDataSuccess(data));
  } catch (e) {
    yield put(getViewDataFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
    else if (e.message !== undefined)
      yield put(errorAlert("Error while fetching data!"));
  }
}

export function* setAllowanceSaga({ payload, onSet }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const data = yield call(
      api(token).post,
      `/api/employee-allowance/${payload.id}`,
      payload.data,
    );
    if (data) {
      yield put(successAlert("Allowance updated successfully!"));
      yield put(setAllowanceSuccess());
      typeof onSet === "function" && onSet();
    }
  } catch (e) {
    yield put(setAllowanceFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
  }
}

export function* deleteLeaveSaga({ payload, onDelete }) {
  const token = yield select((state) => state?.AuthReducer?.token);

  try {
    const data = yield call(
      api(token).delete,
      `/api/employee-leave/${payload}`,
    );
    if (data) {
      yield put(successAlert("Leave deleted successfully!"));
      yield put(deleteLeaveSuccess());
      typeof onDelete === "function" && onDelete();
    }
  } catch (e) {
    yield put(deleteLeaveFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
  }
}

export function* getYearsSaga({ payload, onYearSuccess }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  let query = payload ? QueryString.stringify(payload) : "";
  try {
    const { data } = yield call(api(token).get, `/api/year-list?${query}`);
    yield put(getYearsSuccess(data));
    typeof onYearSuccess === "function" && onYearSuccess(data);
  } catch (e) {
    yield put(getYearsFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
    else if (e.message !== undefined)
      yield put(errorAlert("Error while fetching list!"));
  }
}

export function* fetchHistorySaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  let query = payload?.filters ? QueryString.stringify(payload?.filters) : "";
  try {
    const { data } = yield call(
      api(token).get,
      `/api/leave-history/${payload.company_id}?${query}`,
    );
    yield put(fetchHistorySuccess(data));
  } catch (e) {
    yield put(fetchHistoryFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
    else if (e.message !== undefined)
      yield put(errorAlert("Error while fetching list!"));
  }
}

export function* fetchRequestsSaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  let query = payload?.filters ? QueryString.stringify(payload?.filters) : "";
  try {
    const { data } = yield call(
      api(token).get,
      `/api/v2/work-location-leave/${payload.employee_id}?${query}`,
    );
    yield put(fetchRequestsSuccess(data));
  } catch (e) {
    yield put(fetchRequestsFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
    else if (e.message !== undefined)
      yield put(errorAlert("Error while fetching list!"));
  }
}

// Same endpoint and filters as the list, narrowed to leave needing a
// director's approval; only the length is kept. Fails silently: the count
// is a hint on the toggle, never worth an error toast.
export function* fetchDirectorApprovalCountSaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  const query = QueryString.stringify({
    ...(payload?.filters ?? {}),
    is_manual_override: true,
  });
  try {
    const { data } = yield call(
      api(token).get,
      `/api/v2/work-location-leave/${payload.employee_id}?${query}`,
    );
    yield put(
      fetchDirectorApprovalCountSuccess(Array.isArray(data) ? data.length : 0),
    );
  } catch (e) {
    yield put(fetchDirectorApprovalCountFailure());
  }
}

export function* approveLeaveSaga({ payload, onSuccess }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const { data } = yield call(
      api(token).post,
      `/api/approve-leave/${payload.id}`,
      payload.data,
    );
    yield put(aprroveLeaveSuccess(data));
    typeof onSuccess === "function" && onSuccess();
  } catch (e) {
    yield put(aprroveLeaveFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
    else if (e.message !== undefined)
      yield put(errorAlert("Error while aproving!"));
  }
}

export function* fetchMonthSaga({ payload, onSuccess }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  let query = payload?.filters ? QueryString.stringify(payload?.filters) : "";
  const leaves = yield select((state) => state?.LeaveReducer?.leaves);
  const leaveEmployee = yield select(
    (state) => state?.LeaveReducer?.leaveEmployee,
  );

  try {
    const { data } = yield call(api(token).get, `/api/v2/leave-month?${query}`);
    yield put(fetchMonthSuccess(data));
    typeof onSuccess === "function" && onSuccess(data, leaves, leaveEmployee);
  } catch (e) {
    yield put(fetchMonthFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
    else if (e.message !== undefined)
      yield put(errorAlert("Error while fetching list!"));
  }
}

export function* getHistorySaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const { data } = yield call(
      api(token).get,
      `/api/emp-leave-history/${payload.id}`,
    );
    yield put(getHistorySuccess(data));
  } catch (e) {
    yield put(getHistoryFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
    else if (e.message !== undefined)
      yield put(errorAlert("Error while fetching list!"));
  }
}

function flattenLeavesList(leaves) {
  if (!leaves || typeof leaves !== "object") return [];
  const approved = Array.isArray(leaves.approved) ? leaves.approved : [];
  const pending = Array.isArray(leaves.pending) ? leaves.pending : [];
  const rejected = Array.isArray(leaves.rejected) ? leaves.rejected : [];
  return [
    ...approved.map((item) => ({ ...item, status: "approved" })),
    ...pending.map((item) => ({ ...item, status: "pending" })),
    ...rejected.map((item) => ({ ...item, status: "rejected" })),
  ];
}

export function* getHomeLeavesSaga({ payload, onSuccess }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const { data } = yield call(api(token).post, `/api/get-all-leave`, payload);
    const payloadWithList = {
      ...data,
      leavesList: flattenLeavesList(data?.leaves),
    };
    yield put(getHomeLeavesSuccess(payloadWithList));
    typeof onSuccess === "function" && onSuccess(payloadWithList);
  } catch (e) {
    yield put(getHomeLeavesFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
    else if (e.message !== undefined)
      yield put(errorAlert("Error while fetching list!"));
  }
}

export function* deleteFileSaga({ payload, onDel }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const { data } = yield call(
      api(token).delete,
      `/api/leave-document/${payload}`,
    );
    yield put(deleteFileSuccess(data));
    typeof onDel === "function" && onDel();
  } catch (e) {
    yield put(deleteFileFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
    else if (e.message !== undefined)
      yield put(errorAlert("Error while deleting file!"));
  }
}

export function* fetchReportListSaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  let query = payload?.filters ? QueryString.stringify(payload?.filters) : "";
  try {
    const { data } = yield call(
      api(token).get,
      `/api/leave/manager/pending-approval?${query}`,
    );
    yield put(fetchReportListSuccess(data));
  } catch (e) {
    yield put(fetchReportListFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
    else if (e.message !== undefined)
      yield put(errorAlert("Error while fetching leave!"));
  }
}

export function* getAccrualLeaveSaga({ payload, onSuccess }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  const query = payload?.filters ? QueryString.stringify(payload?.filters) : "";
  let updatedData = yield select((state) => state?.LeaveReducer?.accrualLeave);
  const resetData = payload?.resetData;
  try {
    const { data } = yield call(
      api(token).get,
      `/api/accrual-employee-list?${query}`,
    );

    if (resetData) {
      updatedData = {
        ...data,
      };
    } else {
      updatedData = {
        ...data,
        data: [...(updatedData?.data ?? []), ...data?.data],
      };
    }
    yield put(getAccrualLeaveSuccess(updatedData));
    typeof onSuccess === "function" && onSuccess(updatedData);
  } catch (e) {
    yield put(getAccrualLeaveFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
    else if (e.message !== undefined)
      yield put(errorAlert("Error while fetching accrual leave report!"));
  }
}

export function* getAccrualPeriodSaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const { data } = yield call(api(token).get, `/api/accrual-period`);
    yield put(getAccrualPeriodSuccess(data));
  } catch (e) {
    yield put(getAccrualPeriodFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
    else if (e.message !== undefined)
      yield put(errorAlert("Error while fetching period!"));
  }
}

export function* exportAccrualSaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  const { filters, title } = payload;
  try {
    const data = yield call(
      api(token, null, false, true).post,
      `/api/export-accrual-report`,
      filters,
    );
    if (data) {
      yield put(exportAccrualSuccess());
      const url = window.URL.createObjectURL(new Blob([data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `${title}.csv`);
      document.body.appendChild(link);
      link.click();
    }
  } catch (e) {
    yield put(exportAccrualFailure());
    yield put(errorAlert(`Error while exporting accrual!`));
  }
}

export function* exportLeaveSaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  const { filters, title } = payload;
  try {
    const data = yield call(
      api(token, null, false, true).post,
      `/api/leave-export`,
      filters,
    );
    if (data) {
      yield put(exportLeaveSuccess());
      const url = window.URL.createObjectURL(new Blob([data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `${title}.xlsx`);
      document.body.appendChild(link);
      link.click();
    }
  } catch (e) {
    yield put(exportLeaveFailure());
    yield put(errorAlert(`Error while exporting leave!`));
  }
}

export function* getAvgHoursSaga({ payload, onSuccess }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const { data } = yield call(
      api(token).get,
      `/api/get-avg-hours/${payload}`,
    );
    yield put(getAvgHoursSuccess(data));
    typeof onSuccess === "function" && onSuccess(data);
  } catch (e) {
    yield put(getAvgHoursFailure());
    typeof onSuccess === "function" && onSuccess();
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
    else if (e.message !== undefined)
      yield put(errorAlert("Error while fetching avg hours!"));
  }
}

export function* addLeaveFlow() {
  yield takeEvery(ADD_LEAVE, addLeaveSaga);
}
export function* previewAnnualLeaveFlow() {
  yield takeEvery(PREVIEW_ANNUAL_LEAVE, previewAnnualLeaveSaga);
}
export function* editLeaveFlow() {
  yield takeEvery(EDIT_LEAVE, editLeaveSaga);
}
export function* getViewDataFlow() {
  yield takeEvery(GET_VIEW_DATA, getViewDataSaga);
}
export function* fetchLeaveFlow() {
  yield takeEvery(FETCH_LEAVE, fetchLeaveSaga);
}
export function* setAllowanceFlow() {
  yield takeEvery(SET_ALLOWANCE, setAllowanceSaga);
}
export function* deleteLeaveFlow() {
  yield takeEvery(DELETE_LEAVE, deleteLeaveSaga);
}
export function* getYearsFlow() {
  yield takeEvery(GET_YEARS, getYearsSaga);
}
export function* fetchHistoryFlow() {
  yield takeEvery(FETCH_HISTORY, fetchHistorySaga);
}
export function* fetchRequestsFlow() {
  yield takeEvery(FETCH_REQUESTS, fetchRequestsSaga);
}
export function* fetchDirectorApprovalCountFlow() {
  yield takeLatest(
    FETCH_DIRECTOR_APPROVAL_COUNT,
    fetchDirectorApprovalCountSaga,
  );
}
export function* approveLeaveFlow() {
  yield takeEvery(APRROVE_LEAVE, approveLeaveSaga);
}
export function* fetchMonthFlow() {
  yield takeEvery(FETCH_MONTH, fetchMonthSaga);
}
export function* getHistoryFlow() {
  yield takeEvery(GET_HISTORY, getHistorySaga);
}
export function* getHomeLeavesFlow() {
  yield takeEvery(GET_HOME_LEAVES, getHomeLeavesSaga);
}
export function* deleteFileFlow() {
  yield takeEvery(DELETE_FILE, deleteFileSaga);
}
export function* fetchReportListFlow() {
  yield takeEvery(FETCH_REPORT_LIST, fetchReportListSaga);
}
export function* getAccrualLeaveFlow() {
  yield takeEvery(GET_ACCRUAL_LEAVE, getAccrualLeaveSaga);
}
export function* getAccrualPeriodFlow() {
  yield takeEvery(GET_ACCRUAL_PERIOD, getAccrualPeriodSaga);
}
export function* exportAccrualFlow() {
  yield takeEvery(EXPORT_ACCRUAL, exportAccrualSaga);
}
export function* exportLeaveFlow() {
  yield takeEvery(EXPORT_LEAVE, exportLeaveSaga);
}
export function* getAvgHoursFlow() {
  yield takeEvery(GET_AVG_HOURS, getAvgHoursSaga);
}
export default function* LeaveSaga() {
  yield all([
    addLeaveFlow(),
    previewAnnualLeaveFlow(),
    editLeaveFlow(),
    getViewDataFlow(),
    fetchLeaveFlow(),
    setAllowanceFlow(),
    deleteLeaveFlow(),
    getYearsFlow(),
    fetchHistoryFlow(),
    fetchRequestsFlow(),
    fetchDirectorApprovalCountFlow(),
    approveLeaveFlow(),
    fetchMonthFlow(),
    getHistoryFlow(),
    getHomeLeavesFlow(),
    deleteFileFlow(),
    fetchReportListFlow(),
    getAccrualLeaveFlow(),
    getAccrualPeriodFlow(),
    exportAccrualFlow(),
    exportLeaveFlow(),
    getAvgHoursFlow(),
  ]);
}
